import { CallController } from '@gem/call/CallController/CallController';
import { Call } from '@gem/call/CallStore/Call';
import * as callModel from '@gem/call/Model/callModel';
import { FinishCallReason } from '@gem/call/Model/callModel.types';
import { logger } from '@gem/modules/logger';

export const finishCall = async ({
  call,
  callController,
}: {
  call: Call;
  callController: CallController;
}): Promise<void> => {
  try {
    if (!call) {
      return;
    }

    if (call.channelId) {
      await callModel.finishCall(call.channelId, FinishCallReason.Left);
    }

    if (call.channelId && callController.handlers.feedbackHandler) {
      callController.handlers.feedbackHandler(call.channelId);
    }

    callController.dispose(true, true);
  } catch (e) {
    logger.get('API').error('calls.finishCall', e);
  }
};
